/* HitchFire 2026 — Reviews carousel (Yotpo)
   Inserts a horizontally-scrollable carousel of the product's 10 most recent
   published reviews immediately after the "Build Your Own Kit" (bundle) section.
   5-up on desktop, ~1-up on mobile, with soft faded edges hinting at more cards.
   Runs on product pages only; self-contained (injects its own CSS). */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var started = false;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    if (started) return;
    started = true;

    var pid = productId();
    if (!pid) return;

    var anchor = document.querySelector('[id*="shopify-section"][id*="__bundle"]')
      || document.querySelector('[id*="shopify-section"][id*="bundle"]')
      || document.querySelector('[id*="shopify-section"][id*="__main"]');
    if (!anchor) return;

    injectCss();

    var appKey = yotpoAppKey();
    var host = document.createElement('section');
    host.className = 'hf-rvc';
    host.setAttribute('aria-label', 'Customer reviews');
    host.innerHTML =
      '<div class="hf-rvc__inner">' +
        '<div class="hf-rvc__head">' +
          '<div>' +
            '<div class="hf-rvc__eyebrow">Real Owners · Verified Reviews</div>' +
            '<h2 class="hf-rvc__h2">What The Crew Says</h2>' +
          '</div>' +
          '<div class="hf-rvc__headright">' +
            '<div class="hf-rvc__bl" data-bl></div>' +
            '<a class="hf-rvc__all" data-all href="#reviews">Read all reviews →</a>' +
          '</div>' +
        '</div>' +
        '<div class="hf-rvc__scroll">' +
          '<button type="button" class="hf-rvc__nav hf-rvc__nav--prev is-hidden" data-prev aria-label="Previous reviews">' + chevron('left') + '</button>' +
          '<div class="hf-rvc__track" role="list" data-track></div>' +
          '<button type="button" class="hf-rvc__nav hf-rvc__nav--next" data-next aria-label="Next reviews">' + chevron('right') + '</button>' +
        '</div>' +
      '</div>';
    anchor.parentNode.insertBefore(host, anchor.nextSibling);

    var url = 'https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(appKey) +
      '/products/' + encodeURIComponent(pid) + '/reviews.json?per_page=10&page=1&sort=date&direction=desc';

    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var resp = j && j.response ? j.response : {};
      var revs = (resp.reviews || []).slice(0, 10);
      if (!revs.length) { host.parentNode && host.parentNode.removeChild(host); return; }
      host.querySelector('[data-track]').innerHTML = revs.map(card).join('');
      setupNav(host);
      var bl = resp.bottomline;
      if (bl && bl.total_review) {
        host.querySelector('[data-bl]').innerHTML =
          '<span class="hf-rvc__blstars">' + starRow(bl.average_score) + '</span>' +
          '<span class="hf-rvc__blnum">' + (Math.round(bl.average_score * 10) / 10) + '</span>' +
          '<span class="hf-rvc__blcount">' + bl.total_review + ' reviews</span>';
      }
    }).catch(function () {
      if (host.parentNode) host.parentNode.removeChild(host);
    });
  }

  function chevron(dir) {
    var d = dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 6l6 6-6 6';
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  }

  function setupNav(host) {
    var track = host.querySelector('[data-track]');
    var prev = host.querySelector('[data-prev]');
    var next = host.querySelector('[data-next]');
    if (!track || !prev || !next) return;
    function step() {
      var c = track.querySelector('.hf-rvc__card');
      var w = c ? c.getBoundingClientRect().width : 300;
      var per = Math.max(1, Math.floor(track.clientWidth / (w + 16)) - 1);
      return (w + 16) * per;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('is-hidden', track.scrollLeft <= 6);
      next.classList.toggle('is-hidden', track.scrollLeft >= max);
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var all = host.querySelector('[data-all]');
    if (all) {
      all.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.querySelector('[id*="shopify-section"][id*="__reviews"]')
          || document.getElementById('reviews')
          || document.querySelector('.yotpo-widget-instance,[class*="reviews-main-widget"],[class*="yotpo-main-widget"],[class*="main-widget"]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function productId() {
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) {
        return ShopifyAnalytics.meta.product.id;
      }
    } catch (e) {}
    var el = document.querySelector('[data-yotpo-product-id],[data-product-id]');
    if (el) return el.getAttribute('data-yotpo-product-id') || el.getAttribute('data-product-id');
    return null;
  }

  function yotpoAppKey() {
    var s = document.querySelector('script[src*="yotpo"][src*="/loader/"]');
    if (s) {
      var m = s.src.split('/loader/')[1];
      if (m) return m.split(/[?#]/)[0];
    }
    return 'Bv2b7AghIyPUIopwGybhiXtLs2J7xgfsnRSgr5vs';
  }

  function esc(x) {
    var d = document.createElement('div');
    d.textContent = x == null ? '' : String(x);
    return d.innerHTML;
  }

  function starRow(score) {
    var n = Math.round(score || 0), out = '';
    for (var i = 0; i < 5; i++) out += '<span class="hf-rvc__s' + (i < n ? ' on' : '') + '">★</span>';
    return out;
  }

  function fmtDate(iso) {
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch (e) { return ''; }
  }

  function card(rv) {
    var name = esc((rv.user && rv.user.display_name) || 'Verified Buyer');
    var vb = rv.verified_buyer ? '<span class="hf-rvc__vb">✓ Verified</span>' : '';
    var title = rv.title ? '<h3 class="hf-rvc__title">' + esc(rv.title) + '</h3>' : '';
    var body = esc(rv.content || '');
    return '<article class="hf-rvc__card" role="listitem">' +
        '<div class="hf-rvc__stars">' + starRow(rv.score) + '</div>' +
        title +
        '<p class="hf-rvc__body">' + body + '</p>' +
        '<div class="hf-rvc__meta">' +
          '<span class="hf-rvc__name">' + name + '</span>' + vb +
          '<span class="hf-rvc__date">' + fmtDate(rv.created_at) + '</span>' +
        '</div>' +
      '</article>';
  }

  function injectCss() {
    if (document.getElementById('hf-rvc-css')) return;
    var css =
      '.hf-rvc{background:var(--hf-cream,#F5F1E8);}' +
      '.hf-rvc__inner{max-width:var(--container-wide,1440px);margin:0 auto;padding:clamp(40px,5vw,72px) clamp(16px,3vw,32px);}' +
      '.hf-rvc__head{display:flex;align-items:flex-end;justify-content:space-between;gap:16px;flex-wrap:wrap;margin-bottom:26px;}' +
      '.hf-rvc__eyebrow{font-family:var(--font-sub,"Oswald",sans-serif);font-weight:600;font-size:12px;text-transform:uppercase;letter-spacing:.16em;color:var(--hf-orange,#F15A24);margin-bottom:8px;}' +
      '.hf-rvc__h2{font-family:var(--font-display,"Oswald",sans-serif);font-weight:900;text-transform:uppercase;letter-spacing:-.01em;font-size:clamp(26px,3.4vw,42px);line-height:1;margin:0;color:var(--hf-black,#111);}' +
      '.hf-rvc__headright{display:flex;flex-direction:column;align-items:flex-end;gap:7px;}' +
      '.hf-rvc__bl{display:flex;align-items:center;gap:8px;font-family:var(--font-sub,"Oswald",sans-serif);}' +
      '.hf-rvc__all{font-family:var(--font-sub,"Oswald",sans-serif);font-weight:600;font-size:12.5px;text-transform:uppercase;letter-spacing:.08em;color:var(--hf-black,#111);border-bottom:2px solid var(--hf-orange,#F15A24);padding-bottom:2px;cursor:pointer;text-decoration:none;transition:color .2s ease;}' +
      '.hf-rvc__all:hover{color:var(--hf-orange,#F15A24);}' +
      '@media (max-width:749px){.hf-rvc__headright{align-items:flex-start;}}' +
      '.hf-rvc__blstars .hf-rvc__s{color:#D9D2C7;font-size:16px;}' +
      '.hf-rvc__blstars .hf-rvc__s.on{color:var(--hf-orange,#F15A24);}' +
      '.hf-rvc__blnum{font-weight:700;font-size:16px;color:var(--hf-black,#111);}' +
      '.hf-rvc__blcount{font-size:13px;color:var(--fg-muted,#555A5F);}' +
      '.hf-rvc__scroll{position:relative;}' +
      '.hf-rvc__nav{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:44px;height:44px;border-radius:50%;border:1px solid var(--border,#E2DDD1);background:#fff;color:var(--hf-black,#111);display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 4px 16px rgba(17,17,17,.16);transition:opacity .2s ease,background .2s ease,color .2s ease,border-color .2s ease;}' +
      '.hf-rvc__nav:hover{background:var(--hf-orange,#F15A24);color:#fff;border-color:var(--hf-orange,#F15A24);}' +
      '.hf-rvc__nav--prev{left:-8px;}' +
      '.hf-rvc__nav--next{right:-8px;}' +
      '.hf-rvc__nav.is-hidden{opacity:0;pointer-events:none;}' +
      '@media (max-width:749px){.hf-rvc__nav{display:none;}}' +
      '.hf-rvc__track{display:grid;grid-auto-flow:column;grid-auto-columns:calc((100% - 4*16px)/5);gap:16px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;padding:6px 2px 10px;scrollbar-width:none;' +
        '-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 34px,#000 calc(100% - 34px),transparent 100%);mask-image:linear-gradient(90deg,transparent 0,#000 34px,#000 calc(100% - 34px),transparent 100%);}' +
      '.hf-rvc__track::-webkit-scrollbar{display:none;}' +
      '.hf-rvc__card{scroll-snap-align:start;background:#fff;border:1px solid var(--border,#E2DDD1);border-radius:12px;padding:20px 20px 18px;display:flex;flex-direction:column;gap:9px;min-height:210px;box-sizing:border-box;}' +
      '.hf-rvc__stars .hf-rvc__s{color:#D9D2C7;font-size:15px;letter-spacing:1px;}' +
      '.hf-rvc__stars .hf-rvc__s.on{color:var(--hf-orange,#F15A24);}' +
      '.hf-rvc__title{font-family:var(--font-sub,"Oswald",sans-serif);font-weight:600;font-size:15px;letter-spacing:.01em;margin:0;color:var(--hf-black,#111);line-height:1.3;}' +
      '.hf-rvc__body{font-size:14px;line-height:1.55;color:var(--fg-muted,#555A5F);margin:0;flex:1 1 auto;overflow:hidden;display:-webkit-box;-webkit-line-clamp:6;-webkit-box-orient:vertical;}' +
      '.hf-rvc__meta{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-top:4px;font-family:var(--font-sub,"Oswald",sans-serif);}' +
      '.hf-rvc__name{font-weight:600;font-size:12.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--hf-black,#111);}' +
      '.hf-rvc__vb{font-size:10.5px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;color:#4F7A3E;background:rgba(79,122,62,.12);padding:2px 6px;border-radius:4px;}' +
      '.hf-rvc__date{font-size:12px;color:var(--fg-subtle,#82878B);margin-left:auto;}' +
      '@media (max-width:990px){.hf-rvc__track{grid-auto-columns:calc((100% - 2*16px)/3);}}' +
      '@media (max-width:749px){.hf-rvc__track{grid-auto-columns:86%;gap:14px;}.hf-rvc__card{min-height:0;}}';
    var s = document.createElement('style');
    s.id = 'hf-rvc-css';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
})();
